
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/postal-code-check",
      function () {
        return require("private-next-pages/postal-code-check/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/postal-code-check"])
      });
    }
  